// Treści i opcje wywiadu CV (kafelki, szybkie wybory). Oddzielone od komponentu (i18n-ready).

export const SITUATIONS = [
  { key: "pierwsza", label: "Szukam pierwszej pracy", desc: "Brak doświadczenia zawodowego" },
  { key: "doswiadczenie", label: "Mam doświadczenie", desc: "Pracuję lub pracowałem/am zawodowo" },
  { key: "zmiana", label: "Zmieniam branżę", desc: "Przechodzę do nowego obszaru" },
  { key: "powrot", label: "Wracam po przerwie", desc: "Po dłuższej nieobecności na rynku" },
  { key: "freelancer", label: "Pracuję jako freelancer", desc: "Projekty, zlecenia, własna działalność" },
];

export const WORK_MODES = ["Stacjonarnie", "Hybrydowo", "Zdalnie"];

export const EDU_STATUS = ["W trakcie", "Ukończone", "Przerwane"];

// Popularne języki podpowiadane w pierwszej kolejności.
export const LANG_SUGGEST = ["Angielski", "Niemiecki", "Francuski", "Hiszpański", "Włoski", "Ukraiński", "Rosyjski"];

// Skala poziomu prostym językiem z odpowiednikiem CEFR.
export const LANG_LEVELS = [
  { key: "podstawowy", label: "Podstawowy", cefr: "A1–A2" },
  { key: "komunikatywny", label: "Komunikatywny", cefr: "B1" },
  { key: "srednio", label: "Średniozaawansowany", cefr: "B2" },
  { key: "zaawansowany", label: "Zaawansowany", cefr: "C1" },
  { key: "biegly", label: "Biegły", cefr: "C2" },
  { key: "ojczysty", label: "Ojczysty", cefr: "—" },
];

export const TOOL_LEVELS = ["Podstawowy", "Dobry", "Zaawansowany", "Ekspert"];

export const DRIVING_CATEGORIES = ["AM", "A1", "A2", "A", "B1", "B", "C1", "C", "D1", "D", "BE", "CE", "T"];

export const DOC_LANGS = ["Polski", "Angielski", "Niemiecki"];

// Uniwersalne kompetencje miękkie (gdy brak dopasowania po stanowisku).
const GENERIC_SKILLS = [
  "Komunikatywność", "Praca zespołowa", "Organizacja pracy", "Samodzielność",
  "Odpowiedzialność", "Obsługa klienta", "Dbałość o szczegóły", "Radzenie sobie ze stresem",
];

// Podpowiedzi umiejętności dopasowane do słów kluczowych w nazwie stanowiska.
const ROLE_SKILL_MAP = [
  { kw: ["marketing", "social", "seo", "content", "ads"], skills: ["Google Ads", "Meta Ads", "SEO", "Copywriting", "Analityka (GA4)", "Canva", "Planowanie treści"] },
  { kw: ["sprzedaz", "sprzedaż", "handlow", "sales", "account"], skills: ["Negocjacje", "Obsługa klienta", "CRM", "Prospecting", "Budowanie relacji", "Realizacja celów"] },
  { kw: ["magazyn", "logist", "produkc", "operator"], skills: ["Obsługa wózka widłowego", "Kompletacja zamówień", "Obsługa skanera", "Gospodarka magazynowa", "BHP", "Praca zmianowa"] },
  { kw: ["ksieg", "księg", "finans", "rachun"], skills: ["Księgowość", "Rozliczenia VAT", "PIT/CIT", "Excel", "Comarch Optima", "Analiza finansowa"] },
  { kw: ["program", "developer", "it", "front", "back", "software"], skills: ["JavaScript", "Python", "Git", "REST API", "SQL", "Praca w Scrum"] },
  { kw: ["biur", "asysten", "administr", "recepcj"], skills: ["MS Office", "Obsługa korespondencji", "Kalendarz i spotkania", "Fakturowanie", "Obsługa gości"] },
  { kw: ["gastronom", "kelner", "kuchar", "barista", "restaur"], skills: ["Obsługa gości", "Praca pod presją", "Higiena HACCP", "Obsługa kasy", "Praca zespołowa"] },
  { kw: ["budow", "monter", "instalator", "elektr", "hydraul"], skills: ["Czytanie rysunku technicznego", "Obsługa narzędzi", "BHP na budowie", "Prace wykończeniowe", "Praca w zespole"] },
  { kw: ["beauty", "kosmet", "fryzjer", "stylist", "manicure"], skills: ["Obsługa klienta", "Zabiegi pielęgnacyjne", "Higiena stanowiska", "Doradztwo", "Praca z kalendarzem wizyt"] },
];

export function suggestSkills(role = "") {
  const r = (role || "").toLowerCase();
  for (const m of ROLE_SKILL_MAP) {
    if (m.kw.some((k) => r.includes(k))) return m.skills;
  }
  return GENERIC_SKILLS;
}

// Kroki wywiadu (stała liczba 9). Tytuł + krótki opis.
export const STEPS = [
  { key: "situation", title: "Moja sytuacja zawodowa", desc: "Dobierzemy pytania do Twojej sytuacji." },
  { key: "target", title: "Jakiej pracy szukam", desc: "Stanowisko, branża, lokalizacja i tryb pracy." },
  { key: "contact", title: "Dane kontaktowe", desc: "Dane, które znajdą się w nagłówku CV." },
  { key: "experience", title: "Doświadczenie", desc: "Firmy, stanowiska i zakres obowiązków." },
  { key: "education", title: "Edukacja", desc: "Szkoły, kierunki i status nauki." },
  { key: "skills", title: "Umiejętności", desc: "Kompetencje, narzędzia i programy." },
  { key: "languages", title: "Języki", desc: "Znajomość języków przez Ciebie." },
  { key: "extras", title: "Kursy, certyfikaty i dodatkowe informacje", desc: "Uprawnienia, projekty, zainteresowania." },
  { key: "review", title: "Podsumowanie i język dokumentu", desc: "Sprawdź dane i wybierz język CV." },
];
